import { Alert } from '@mui/material';
import { CustomContentProps, SnackbarProvider as NotistackSnackbarProvider } from 'notistack';
import React, { ReactNode } from 'react';

type SnackbarProviderProps = {
  readonly children: ReactNode;
};

const SnackbarComponent = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => (
  <Alert ref={ref} elevation={4} severity={props.variant === 'default' ? 'info' : props.variant}>
    {props.message}
  </Alert>
));

SnackbarComponent.displayName = 'SnackbarComponent';

export function SnackbarProvider({ children }: SnackbarProviderProps) {
  return (
    <NotistackSnackbarProvider
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      maxSnack={3}
      Components={{
        warning: SnackbarComponent,
        error: SnackbarComponent,
        info: SnackbarComponent,
        default: SnackbarComponent,
        success: SnackbarComponent
      }}>
      {children}
    </NotistackSnackbarProvider>
  );
}
